<template>
    <div>
        <div class="jumbotron-container mb-5 bg-gradient">
            <div class="jumbotron jumbotron-select jumbotron-fluid text-white py-5 bg-gradient">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-8">
                            <h1 class="mb-4 font-weight-light">{{ __('lang.shoppingcart.head') }}</h1>
                        </div>
                    </div>
                    <div class="row justify-content-between align-items-end">
                        <div class="col-12 col-md-6 mb-1">
                            <h5>{{ __('lang.shoppingcart.addproductquick') }}</h5>
                            <!-- <form class="form-inline needs-validation" action="" method="post"> -->
                            <div class="input-group w-100">

                                <productsearch parentID="shoppingcart"></productsearch>

                                <!-- <input class="form-control rounded-left" name="keyword" type="search" :placeholder="__('lang.shoppingcart.addproductplaceholder')"
                                    required>
                                  <div class="input-group-append">
                                    <button class="btn btn-gray-50 w-100 border-0" role="button" data-toggle="modal" data-target="#fullModal" data-content="basket-add" @click="setCartItem('productdata',-1)"><span class="sr-only">{{__('lang.shoppingcart.add')}}</span>
                                      <svg class="icon icon-sm m-0">
                                        <use xlink:href="/assets/img/icon-sprite.svg#global.in-cart-alternative"
                                          xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                      </svg>
                                    </button>
                                  </div> -->
                            </div>
                            <!--  </form> -->
                        </div>
                        <div class="col-12 col-md-3 text-right mb-1"><a class="btn btn-white text-primary col-12 col-md-9  order-12 order-md-1" role="button"
                                                                        data-toggle="modal" data-target="#formModalCartDelete" data-content="basket-delete">
                            <svg class="icon icon-xs">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.delete-alternative"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>{{ __('lang.btn.shoppingcart.delete') }}</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <configurationhead></configurationhead>
        </div>
        <div class="container mb-5">

            <div class="row mb-4">
                <div class="col-12"><a class="btn text-primary d-none d-md-inline pl-0" @click.prevent="set_contentnav">
                    <svg class="icon icon-xs">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.previous" xmlns:xlink="http://www.w3.org/1999/xlink">
                        </use>
                    </svg>{{ __('lang.shoppingcart.moreproducts') }}</a>
                </div>
            </div>

            <!-- <div class="row">
             {{configuration}}
              <div class="form-row" v-if="project.configuration !== null">
                <div class="form-group col">
                  <label class="col-form-label col-form-label-sm" for="description">{{__('lang.shoppingcart.save.description')}}</label>
                  <input class="form-control form-control-plaintext border-0 bg-transparent" name="description" id="description" disabled v-model="project.configuration.description"/>
                </div>
                <div class="form-group col">
                  <label class="col-form-label col-form-label-sm" for="editor">{{__('lang.shoppingcart.save.editor')}}</label>
                  <input class="form-control form-control-plaintext border-0 bg-transparent" name="editor" id="editor" disabled v-model="project.configuration.editor"/>
                </div>
              </div> -->

            <!-- <div class="col-12"> -->
            <!-- Pagenation and Filtering:
                <b-form-fieldset horizontal label="Rows per page" class="col-6" label-size="6">
                  <b-form-select :options="[{text:5,value:5},{text:10,value:10},{text:15,value:15}]" v-model="perPage">
                  </b-form-select>
                </b-form-fieldset>

                <b-form-fieldset horizontal label="Filter" class="col-6" label-size="2">
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                </b-form-fieldset> -->




            <!-- Pagenation and Filtering:
                 <div class="justify-content-center row my-1">
                  <b-pagination size="md" :total-rows="this.shoppingcartlist.length" :per-page="perPage" v-model="currentPage" />
                </div> -->
            <!--   </div>
            </div> -->
            <div class="row">
                <div class="col-12">
                    <div class="col-12">
                        <!--  <a class="btn btn-gray-70 mr-3"  @click="addnewposition(-1)">{{ __('lang.shoppingcart.add.titleposition')}}</a>
                        <a class="btn btn-gray-70 mr-3" @click="addnewposition(-2)">{{ __('lang.shoppingcart.add.subsummeposition')}}</a> -->
                        <b-checkbox v-model="discountshow" inline>{{ __('lang.shoppingcart.add.withdiscount') }}</b-checkbox>
                    </div>

                    <table class="table table-basket table-responsive-md mb-1">
                        <thead>
                        <tr class="small">
                            <th class="border-top-0" v-for="col in table_fields_cart" :key="col.key" scope="col">
                                {{ col.label }}</th>
                        </tr>
                        </thead>
                        <draggable v-model="shoppingcartlist" tag="tbody" handle=".handle" @end="savelist" v-bind="draggableOptions" > <!-- :options="draggableOptions" -->
                            <tr v-for="(row, key) in shoppingcartlist" :key="key" draggable="true" > <!--  :count="getCount(row,key)"   @drop="onDrop() -->
                                <!--   <td scope="row" class="text-center"><input type="checkbox" v-model="selectedItems" :value="row.pos" /></td> -->

                                <template v-if="row.productmarker == -1">
                                    <td scope="row" class="text-center border-b-red"><!--   {{ (key + 1) }}  {{ counter++ }} -->
                                        <div class="text-gray-50 d-block handle" role="button">
                                            <svg class="icon icon-sm mr-0">
                                                <use xlink:href="/assets/img/icon-sprite.svg#global.sort-drag"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </div>
                                    </td>
                                    <td scope="row" class="text-center border-b-red" :colspan="discountshow ? 11 : 9">
                                        <b-form-input class="form-control border-0 bg-white" type="text" :id="'titleposition' + key"
                                                      v-model="shoppingcartlist[key].type" :placeholder="placeholder_title"></b-form-input>
                                    </td>
                                    <td class="border-b-red">
                                        <!-- <a class="text-primary" role="button" data-toggle="modal" data-target="#formModal" data-content="basket-item-delete"
                                        @click="setCartItem(row,key)">
                                        <svg class="icon icon-sm mr-0">
                                          <use xlink:href="/assets/img/icon-sprite.svg#global.delete" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                      </a> -->
                                        <div class="dropdown">
                                            <button class="btn btn-sm btn-gray-50 text-white border-0 dropdown-toggle no-arrow" type="button"
                                                    id="dropdownMenuVTG2389FButton" data-toggle="dropdown" data-display="static"
                                                    aria-haspopup="true" aria-expanded="false">
                                                ...
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right bg-secondary border-0"
                                                 aria-labelledby="dropdownMenuVTG2389FButton">
                                                <a class="dropdown-item text-white text-center" role="button" data-toggle="modal"
                                                   data-target="#formModal" data-content="basket-item-delete" @click="setCartItem(row, key)">{{
                                                        __('lang.shoppingcart.itemdelete')
                                                    }}</a>
                                                <a class="dropdown-item text-white text-center" role="button"
                                                   @click="addnewposition(-1, key)">{{
                                                        __('lang.shoppingcart.add.titleposition')
                                                    }}</a>
                                                <a class="dropdown-item text-white text-center" role="button"
                                                   @click="addnewposition(-2, key)">{{
                                                        __('lang.shoppingcart.add.subsummeposition')
                                                    }}</a>
                                            </div>
                                        </div>
                                    </td>

                                </template>
                                <template v-if="(row.productmarker == -2)">
                                    <td scope="row" class="text-center"><!--        {{ (key + 1) }}  {{ counter++ }} -->
                                        <div class="text-gray-50 d-block handle" role="button">
                                            <svg class="icon icon-sm mr-0">
                                                <use xlink:href="/assets/img/icon-sprite.svg#global.sort-drag"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </div>
                                    </td>
                                    <td class="text-right bg-gray-40 border-t-grey" :colspan="discountshow ? 9 : 7">
                                        <b-form-input class="form-control border-0  bg-gray-40 " type="text" :id="'subsummeposition' + key"
                                                      v-model="shoppingcartlist[key].type" :placeholder="placeholder_subsumme"></b-form-input>
                                    </td>
                                    <td class="text-right bg-gray-40">{{ __('lang.shoppingcart.pricesubtotal') }}</td>
                                    <td class="bg-gray-40 text-right">

                                        <b-form-input class="form-control border-0  bg-gray-40 d-none" :id="'subsummeposition_value' + key"
                                                      v-model="shoppingcartlist[key].subsum" readonly></b-form-input>

                                        {{ shoppingcartsubsumme(key) }}</td>
                                    <td>
                                        <!-- <a class="text-primary" role="button" data-toggle="modal" data-target="#formModal" data-content="basket-item-delete"
                                        @click="setCartItem(row,key)">
                                        <svg class="icon icon-sm mr-0">
                                          <use xlink:href="/assets/img/icon-sprite.svg#global.delete" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                      </a> -->
                                        <div class="dropdown">
                                            <button class="btn btn-sm btn-gray-50 text-white border-0 dropdown-toggle no-arrow" type="button"
                                                    id="dropdownMenuVTG2389FButton" data-toggle="dropdown" data-display="static"
                                                    aria-haspopup="true" aria-expanded="false">
                                                ...
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right bg-secondary border-0"
                                                 aria-labelledby="dropdownMenuVTG2389FButton">
                                                <a class="dropdown-item text-white text-center" role="button" data-toggle="modal"
                                                   data-target="#formModal" data-content="basket-item-delete" @click="setCartItem(row, key)">{{
                                                        __('lang.shoppingcart.itemdelete')
                                                    }}</a>
                                                <a class="dropdown-item text-white text-center" role="button"
                                                   @click="addnewposition(-1, key)">{{
                                                        __('lang.shoppingcart.add.titleposition')
                                                    }}</a>
                                                <a class="dropdown-item text-white text-center" role="button"
                                                   @click="addnewposition(-2, key)">{{
                                                        __('lang.shoppingcart.add.subsummeposition')
                                                    }}</a>
                                            </div>
                                        </div>
                                    </td>
                                </template>

                                <template v-if="(row.productmarker != -1 && row.productmarker != -2)">
                                    <td scope="row" class="text-center"> {{ row.incrementedColumn }} <!--   {{ (key + 1) }}                  {{ (key + 1) - (shoppingcartlist.filter(item => item.productmarker == -1 && key <= key).length) }}  --><!-- {{ counter++ }} -->
                                        <div class="text-gray-50 d-block handle" role="button">
                                            <svg class="icon icon-sm mr-0">
                                                <use xlink:href="/assets/img/icon-sprite.svg#global.sort-drag"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </div>
                                    </td>
                                    <td class="img-td px-0 text-center">
                    <span v-if="row.product_source != 2">
                      <router-link
                          :to="{ name: 'productdetail', query: query_params(row.ref_no, row.version, row.flag_fan, row.execution, row) }"
                          role="button" target="_blank">
                        <span @click.prevent="opendetail(row.ref_no, row.version, row.flag_fan, row.execution, row)" role="link">
                          <b-img class="img-fluid" :src="row.image?mediaserver_url + row.image:''" fluid></b-img>
                        </span>
                      </router-link>
                      <span v-if="row.countaccessories > 0">
                        <button class="btn btn-link btn-sm p-0 mb-1 ml-3 text-primary" role="button" data-toggle="modal"
                                data-target="#fullModal" data-content="accessories-add" @click="setCartItem(row, key)">
                          <svg class="icon icon-xxs">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.arrow"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                          </svg>{{ __('lang.shoppingcart.selectaccessories') }}
                        </button>
                      </span>
                    </span>
                                    </td>
                                    <td scope="row" class="text-center">{{ row.ref_no }}</td>
                                    <td>
                    <span v-if="row.product_source != 2">
                      <!-- <router-link
                        :to="{ name: 'productdetail', query: query_params(row.ref_no, row.version, row.flag_fan, row,row.execution) }"
                        role="button" target="_blank" class="text-primary">
                        <span @click.prevent="opendetail(row.ref_no, row.version, row.flag_fan, row, row.execution)"
                          role="link">{{ row.type }}
                          <span class="small"  v-if="row.execution == 1"> ({{ __('lang.highcharts.blowout.bothsidesradial') }})</span>
                            <span class="small"  v-else-if="row.execution == 3"> ({{ __('lang.highcharts.blowout.axial') }})</span>
                            <span class="small"  v-else-if="row.execution == 2"> ({{ __('lang.highcharts.blowout.radial') }})</span>
                            <span class="small "  v-else></span>

                          <br>
                        </span>
                      </router-link>
                      {{ row.description_short }} -->
                       <template>

                          <div :id="'hoverBtnId_' + row.ref_no + '_' + key">
                            <b-button  variant="link" v-b-tooltip.hover class="text-left p-0">
                                <span><router-link
                                    :to="{ name: 'productdetail', query: query_params(row.ref_no, row.version, row.flag_fan, row.execution, row) }"
                                    role="button" target="_blank" class="text-primary">
                                    <span @click.prevent="opendetail(row.ref_no, row.version, row.flag_fan, row.execution, row)"
                                          role="link">{{ row.type }}
                                      <span class="small"  v-if="row.execution == 1"> ({{ __('lang.highcharts.blowout.bothsidesradial') }})</span>
                                        <span class="small"  v-else-if="row.execution == 2"> ({{ __('lang.highcharts.blowout.axial') }})</span>
                                        <span class="small"  v-else-if="row.execution == 3"> ({{ __('lang.highcharts.blowout.radial') }})</span>
                                        <span class="small "  v-else></span>

                                      <br>
                                    </span>
                                  </router-link>
                                </span>
                            </b-button><br>
                             {{ row.description_short }}
                          </div>
                          <b-popover :target="'hoverBtnId_' + row.ref_no +'_'+key" triggers="hover" placement="auto"  custom-class="quickview">

                              <template v-slot:default>
                                <div class="media">
                                    <div>
                                        <b-img class="img-fluid" :src="row.image ? mediaserver_url + row.image : ''" fluid></b-img>
                                    </div>
                                    <div><h6>{{ row.type }}</h6>
                                         <p>{{ getLongDesc(row.description_long) }}</p>
                                    </div>
                                </div>
                              </template>
                          </b-popover>
                        </template>
                    </span>
                                        <span v-else><span class="text-primary">{{ row.type }}</span><br>
                               {{ row.description_short }}</span>
                                        <br>
                                        <!-- <span v-if="row.hasOwnProperty('positiontext') && row.positiontext!='' && row.positiontext!=null">
                                        <small class="d-block font-weight-normal mt-3">{{__('lang.shoppingcart.position.head')}}</small>
                                        <span class="d-block">{{row.positiontext}}</span>
                                        <a class="btn btn-link btn-sm text-gray-50 my-3 p-0" role="button" data-toggle="modal"
                                          data-target="#formModalPosition" data-content="position-description-add"
                                          @click="setCartItem(row,key)">{{__('lang.shoppingcart.position.change')}}</a>
                                      </span>
                                      <span v-else>
                                        <a class="btn btn-link btn-sm text-gray-50 my-3 p-0" role="button" data-toggle="modal"
                                          data-target="#formModalPosition" data-content="position-description-add"
                                          @click="setCartItem(row,key)">{{__('lang.shoppingcart.position.add')}}</a>
                                      </span> -->
                                        <span v-if="row.hasOwnProperty('positiontext') && row.positiontext != '' && row.positiontext != null">
                      <small class="d-block font-weight-normal mt-3">{{ __('lang.shoppingcart.position.head') }}</small>
                      <span class="d-block">{{ row.positiontext }}</span>
                    </span>
                                        <span v-if="row.validstate == 0"
                                              class="text-primary"><br>{{ __('lang.shoppingcart.product.notavailable') }}</span>

                                    </td>
                                    <td><div class="pt-2">{{ row.wg }}</div></td>
                                    <td>
                                        <b-form-input class="form-control slim" type="number" min="1" :id="'cart_quantity' + key" step="1"
                                                      v-model="shoppingcartlist[key].quantity"></b-form-input> <!-- @input="shoppingcartrowsumme(row.price, shoppingcartlist[key].quantity, row.discount_1, row.discount_2,
                          row.productmarker)" -->

                                    </td>
                                    <td><div class="pt-2">{{ shoppingcartrowprice(row.listprice) }}</div></td>

                                    <td>
                                        <b-form-input class="form-control slim-m" :id="'cart_price' + key" step="0.01"
                                                      v-model.number="shoppingcartlist[key].price"  @blur="formatPrice(key)"></b-form-input> <!-- @keypress="isNumber($event)"-->


                                    </td>
                                    <td v-if="discountshow">
                                        <b-form-input class="form-control slim" type="number" min="0" :id="'cart_disc1' + key" step="1"
                                                      v-model="shoppingcartlist[key].discount_1"></b-form-input>
                                    </td>
                                    <td v-if="discountshow">
                                        <b-form-input class="form-control slim" type="number" min="0" :id="'cart_disc2' + key" step="1"
                                                      v-model="shoppingcartlist[key].discount_2"></b-form-input>
                                    </td>
                                    <td>
                                        <b-form-select class="form-control slim-lg" v-model="shoppingcartlist[key].productmarker" :id="'productmarker' + key"
                                                       :options="productmarker_options.filter(opt => opt.visible == true)"></b-form-select>
                                    </td>
                                    <td :class="shoppingcartrowsumme(row.price, row.quantity, row.discount_1, row.discount_2,
                    row.productmarker) > 0 ? 'text-right' : 'text-center'" ><div class="pt-2">{{
                                            shoppingcartrowsumme(row.price, row.quantity, row.discount_1, row.discount_2,
                                                row.productmarker)
                                        }}</div></td>
                                    <td>
                                        <!--   <a class="text-primary" role="button" data-toggle="modal" data-target="#formModal"
                                        data-content="basket-item-delete" @click="setCartItem(row,key)">
                                        <svg class="icon icon-sm mr-0">
                                          <use xlink:href="/assets/img/icon-sprite.svg#global.delete"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                      </a> -->
                                        <div class="dropdown">
                                            <button class="btn btn-sm btn-gray-50 text-white border-0 dropdown-toggle no-arrow" type="button"
                                                    id="dropdownMenuVTG2389FButton" data-toggle="dropdown" data-display="static"
                                                    aria-haspopup="true" aria-expanded="false">
                                                ...
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right bg-secondary border-0" aria-labelledby="dropdownMenuVTG2389FButton">
                                                <a class="dropdown-item text-white text-center" role="button" data-toggle="modal"
                                                   data-target="#formModal" data-content="basket-item-delete" @click="setCartItem(row, key)">{{
                                                        __('lang.shoppingcart.itemdelete')
                                                    }}
                                                </a>
<!--                                                <a class="dropdown-item text-white text-center" role="button"
                                                   @click="addnewposition(-1, key)">{{ __('lang.shoppingcart.add.titleposition') }}
                                                </a>
                                                <a class="dropdown-item text-white text-center" role="button"
                                                   @click="addnewposition(-2, key)">{{ __('lang.shoppingcart.add.subsummeposition') }}
                                                </a>
                                                <span v-if="row.hasOwnProperty('positiontext') && row.positiontext != '' && row.positiontext != null">
                                                  <a class="dropdown-item text-white text-center" role="button" data-toggle="modal"
                                                     data-target="#formModalPosition" data-content="position-description-add"
                                                     @click="setCartItem(row, key)">{{ __('lang.shoppingcart.position.change') }}
                                                  </a>
                                                </span>
                                                <span v-else>
                                                  <a class="dropdown-item text-white text-center" role="button" data-toggle="modal"
                                                     data-target="#formModalPosition" data-content="position-description-add"
                                                     @click="setCartItem(row, key)">{{ __('lang.shoppingcart.position.add') }}
                                                  </a>
                                                </span>-->
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </draggable>
                        <tfoot>
                        <tr>
                            <td class="text-right font-weight-bold" :colspan="discountshow ? 11 : 9">
                                {{ __('lang.shoppingcart.pricetotal') }}</td>
                            <td class="font-weight-bold text-center" colspan="2">{{ shoppingcartsumme }}</td>

                        </tr>
                        </tfoot>
                    </table>
<!--                    <div class="row justify-content-end" v-if="user.auth">
                        <div class="col">
                            <button class="btn text-primary d-md-inline pl-0" type="button" data-toggle="modal"
                                    data-target="#ownArticleCreateModal" data-content="article-add" @click="getUserArticles">+ {{
                                    __('lang.my_account.add_article')
                                }}</button>
                        </div>
                    </div>-->
                </div>

            </div>
            <div class="row justify-content-end mt-2">
                <div class="col-12 col-md-12"><a class="btn text-primary d-md-inline pl-0"
                                                @click.prevent="set_contentnav">
                    <svg class="icon icon-xs">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.previous" xmlns:xlink="http://www.w3.org/1999/xlink">
                        </use>
                    </svg>{{ __('lang.shoppingcart.moreproducts') }}</a>
                </div> <!--  d-none  -->
                <FORM  action="https://felderer.de/elbridge/accept/?supplier=Helios" method="post" name="start" enctype="multipart/form-data" target="_parent" class="w-100">
                <div class="col-12 col-md-12">
                    <INPUT type="hidden" id="version" name="version"  value=""/>
                    <INPUT type="hidden" id="result" name="result" value="" />
                    <p class="text-right">
                        <a class="btn btn-primary border-0 mr-3 form-group  col-12 col-md-3 order-1 order-md-2"
                           @click.prevent="sendToFelderer">{{ __('lang.shoppingcart.pricecalculation') }}
                        </a>


                        <!--   Test for API gesamt WK

                        <a class="btn btn-gray-70 mr-3" v-if="configuration !== null" @click="getWKArticles">WKArticles
                          <svg class="icon icon-xs mr-2">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.save" xmlns:xlink="http://www.w3.org/1999/xlink">
                            </use>
                          </svg>
                        </a>

                        -->
                        <!--  <a class="btn btn-primary form-group  col-12 col-md-4 order-1 order-md-1"  v-if="configuration !== null && user.auth"  @click="resetConfiguration">{{ __('lang.btn.configuration.reset') }} </a> -->
<!--  Felderer                      <a class="btn btn-gray-70 mr-3 form-group  col-12 col-md-4 order-1 order-md-1" role="button" data-toggle="modal" v-if="configuration !== null && user.auth"
                           data-target="#formModalConfigurationReset" data-content="configuration-reset">{{ __('lang.btn.configuration.reset') }}</a>


                        <a class="btn btn-gray-70 mr-3 form-group  col-12 col-md-3 order-1 order-md-2" v-if="configuration !== null && user.auth && !project.useraccess"
                           @click="updateConfiguration">{{ __('lang.btn.save') }}
                            <svg class="icon icon-xs mr-2">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.save" xmlns:xlink="http://www.w3.org/1999/xlink">
                                </use>
                            </svg>
                        </a>
                        <button v-else class="btn btn-gray-70 mr-3 form-group  col-12 col-md-3 order-1 order-md-1" @click.prevent="setProjectData" :disabled="state_button" data-toggle="modal" data-target="#formModalSave">
                            {{ __('lang.btn.save') }}
                            <svg class="icon icon-xs ml-2">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.save" xmlns:xlink="http://www.w3.org/1999/xlink">
                                </use>
                            </svg>
                        </button>-->

                        <!--  <a class="btn btn-gray-70 mr-3" v-else role="button" data-toggle="modal" data-target="#formModalSave"
                           @click="setProjectData" data-content="basket-save"  :disabled="state_button">{{ __('lang.btn.save') }}
                           <svg class="icon icon-xs ml-2">
                             <use xlink:href="/assets/img/icon-sprite.svg#global.save" xmlns:xlink="http://www.w3.org/1999/xlink">
                             </use>
                           </svg>
                         </a> -->

<!--  Felderer                   <button v-if="state_button_output" class="btn btn-gray-70 mr-3 form-group  col-12 col-md-3 order-1 order-md-1" disabled>{{ __('lang.btn.output') }}
                            <svg class="icon icon-xs ml-2">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.exit" xmlns:xlink="http://www.w3.org/1999/xlink">
                                </use>
                            </svg>
                        </button>
                        <a v-else class="btn btn-primary form-group  col-12 col-md-3 order-12 order-md-1" role="button" data-toggle="modal" data-target="#formModalOutput"
                           data-content="output-options">{{ __('lang.btn.output') }}
                            <svg class="icon icon-xs ml-2">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.exit" xmlns:xlink="http://www.w3.org/1999/xlink">
                                </use>
                            </svg>
                        </a>-->
                    </p>
                </div>
                </FORM>
            </div>
        </div>
        <!-- Positiontext -->
        <div class="modal right fade" id="formModalPosition" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog shadow-lg mx-0">
                <div class="modal-content rounded-0 border-0 pb-4">
                    <div class="modal-header justify-content-end border-0">
                        <button class="close mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close"
                                id="closeModalPosition"><span aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <positiontext :parent_product="shoppingcart_item"></positiontext>
                    </div>
                </div>
            </div>
        </div>
        <!-- Item Delete -->
        <div class="modal right fade" id="formModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog shadow-lg mx-0">
                <div class="modal-content rounded-0 border-0 pb-4">
                    <div class="modal-header justify-content-end border-0">
                        <button class="close mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close" id="closeModal"><span
                            aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <itemdelete :shoppingcart_item="shoppingcart_item" ref="shoppingcartdelete"></itemdelete>
                    </div>
                </div>
            </div>
        </div>
        <!-- Add Accessories -->
        <div class="modal fade" id="fullModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div class="modal-content rounded-lg border-0 shadow-lg">
                    <div class="modal-header justify-content-end border-0">
                        <button class="close ml-auto mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close"
                                id="closeModalAccessories">
              <span aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg>
              </span>
                        </button>
                    </div>
                    <div class="modal-body" width="300" height="300">
                        <accessories ref="add_from_shoppingcart" parentID="shoppingcart" :parent_product="shoppingcart_item">
                        </accessories>
                    </div>
                    <div class="modal-footer justify-content-center border-0">
                        <button class="btn btn-gray-50 text-white" type="reset" data-dismiss="modal">
                            <svg class="icon">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset"
                                     xmlns:xlink="http://www.w3.org/1999/xlink">
                                </use>
                            </svg>{{ __('lang.btn.back') }}
                        </button><a class="btn btn-primary border-0"
                                    @click.prevent="$refs.add_from_shoppingcart.storeSelectedProducts()">{{ __('lang.btn.tocart') }}</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Shoppingcart save  -->
        <div class="modal right fade" id="formModalSave" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog shadow-lg mx-0">
                <div class="modal-content rounded-0 border-0 pb-4">
                    <div class="modal-header justify-content-end border-0">
                        <button class="close mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close"
                                id="closeModalSave"><span aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <shoppingcartsave ref="shoppingcartsave"></shoppingcartsave>
                    </div>
                </div>
            </div>
        </div>
        <!-- Shoppingcart output  -->
        <div class="modal right fade" id="formModalOutput" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog shadow-lg mx-0">
                <div class="modal-content rounded-0 border-0 pb-4">
                    <div class="modal-header justify-content-end border-0">
                        <button class="close mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close"
                                id="closeModalOutput"><span aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <shoppingcartoutput ref="shoppingcartoutput" :discountshow="discountshow"></shoppingcartoutput>
                    </div>
                </div>
            </div>
        </div>
        <!-- Shoppingcart delete  -->
        <div class="modal right fade" id="formModalCartDelete" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog shadow-lg mx-0">
                <div class="modal-content rounded-0 border-0 pb-4">
                    <div class="modal-header justify-content-end border-0">
                        <button class="close mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close"
                                id="closeModalCartDelete"><span aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <shoppingcartdelete ref="shoppingcartdelete"></shoppingcartdelete>
                    </div>
                </div>
            </div>
        </div>
        <!-- Add own article  -->
        <div class="modal right fade" id="ownArticleCreateModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal_xl shadow-lg mx-0">
                <div class="modal-content rounded-0 border-0 pb-4">
                    <button class="close ml-auto mt-3 mr-4" type="button" id="closeOwnArticleCreateModal" data-dismiss="modal"
                            aria-label="Close">
            <span aria-hidden="true">
              <svg class="icon icon-xs">
                <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                </use>
              </svg>
            </span>
                    </button>
                    <div class="modal-body">
                        <ownArticleCreate ref="ownArticleCreate"></ownArticleCreate>
                    </div>
                </div>
            </div>
        </div>
        <!-- Configuration Reset-->
        <div class="modal right fade" id="formModalConfigurationReset" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog shadow-lg mx-0">
                <div class="modal-content rounded-0 border-0 pb-4">
                    <div class="modal-header justify-content-end border-0">
                        <button class="close mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close" id="closeModalConfigurationReset"><span
                            aria-hidden="true">
                  <svg class="icon icon-xs">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                    </use>
                  </svg></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <configurationreset></configurationreset> <!--  :shoppingcart_item="shoppingcart_item" ref="shoppingcartdelete" -->
                    </div>
                </div>
            </div>
        </div>




    </div>
</template>

<script>
import productdataApi from './services/api/productdataAPI.js'
import accessories from './Accessories'
import positiontext from './ShoppingCartPositiontextAdd'
import itemdelete from './ShoppingCartItemDelete'
import shoppingcartsave from './ShoppingCartSave'
import shoppingcartoutput from './ShoppingCartOutput'
import shoppingcartdelete from './ShoppingCartDelete'
import productsearch from './ProductSearch'
import ownArticleCreate from './OwnArticleCreate'

import draggable from "vuedraggable"
import configurationhead from './ConfigurationHead'
import configurationreset from './ConfigurationReset'
import felderer from './services/api/felderer.js'
import userApi from "./services/api/user";
import globalsApi from "./services/api/globals";


/* import draggable, { Sortable, MultiDrag } from 'vuedraggable'; // @David-Desmaisons David-Desmaisons mentioned this issue Oct 13, 2020: Vue.Draggable do not support multiple drags

Sortable.mount(new MultiDrag())
 */
let from_k = 0
export default {
    components: {
        accessories,
        positiontext,
        itemdelete,
        shoppingcartsave,
        shoppingcartoutput,
        shoppingcartdelete,
        productsearch,
        ownArticleCreate,
        draggable,
        configurationhead,
        configurationreset
    },

    computed: {
        state_button() {
            return !this.user.auth || this.shoppingcartlist.length==0 || this.project.useraccess == true
        },
        state_button_output() {
            return this.shoppingcartlist.length == 0
        },
        reRenderShoppingcart: {
            get() {
                return this.$store.state.shoppingcart.reRenderShoppingcart
            },
            set(value) {
                this.$store.commit('shoppingcart/updatereRenderShoppingcart', value)
            }
        },
        table_fields_cart: {
            get() {
                return this.setFieldLabels(this.$store.state.shoppingcart.table_fields_cart).filter(field => field.visible)
            }
        },
        /*  media_dir : {
           get () {
               return this.$store.state.productdata.media_dir
           }
         }, */
        shoppingcartlist: {
            get() {
                var localshoppingcart = this.$store.state.shoppingcart.shoppingcartlist   //.sort((a, b) => a.position - b.position)
                /* var idx_increment=0
                 var locsc = localshoppingcart.map(row => {

                   if (row.productmarker === 0) {
                       idx_increment++
                       return { ...row, incrementedColumn: idx_increment };
                     }
                     return { ...row, incrementedColumn: 0 };
                   });
          */


                var idx_increment = 0
                localshoppingcart.filter(row => row.productmarker != -1 && row.productmarker != -2).forEach(function (row) {
                    idx_increment++
                    Object.assign(row, {
                        incrementedColumn: idx_increment
                    });

                })
                return this.getProductInfo() // for description_long in popover


                /* comment for description_long in popover
                        if (this.reRenderShoppingcart == 1) return this.getProductInfo()
                        else return localshoppingcart */
                //  return this.getProductInfo()

            },
            set(value) {
                this.$store.commit('shoppingcart/updateShoppingcartList', value)
            }
        },
        shoppingcartnetto: {
            get() {
                return this.$store.state.shoppingcart.shoppingcartnetto
            },
            set(value) {
                this.$store.commit('shoppingcart/updateShoppingcartnetto', value)
            }
        },

        shoppingcartsumme() {
            var returnvalue
            if (!this.user.auth) returnvalue = this.__('lang.message.loginrequired');
            else if (this.user.countries_price == '') returnvalue = this.__('lang.global.onrequest');// + ' PreisLand unbekannt';
                /*   else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) returnvalue = this.__('lang.global.onrequest'); //+ ' fremdes Land'; */
            // 2023-11-28 editprices => sollte grechnet werden mit editprice else if (this.user.auth && this.user.countries_price != this.selectedlocale.country ) returnvalue = this.__('lang.global.onrequest'); //+ ' fremdes Land';
            else {
                var buildssum = true
                var sum = this.shoppingcartlist.reduce((accum, item) => {

                    if (item.productmarker == 0 && (isNaN(item.price) || parseFloat(item.price) == 0 || item.price == null)) {
                        buildssum = false
                        return
                    } else if (item.productmarker != 0 || item.productmarker == -1 || item.productmarker == -2) {
                        return accum += 0
                    } else {
                        if (this.discountshow) return accum += parseInt(item.quantity) * (parseFloat(item.price) * (100 - parseFloat(item.discount_1)) / 100) * (100 - parseFloat(item.discount_2)) / 100
                        else return accum += parseInt(item.quantity) * parseFloat(item.price)
                    }
                }, 0.00)

                if (buildssum) returnvalue = sum.toFixed(2)
                else returnvalue = this.__('lang.global.onrequest')
            }
            this.shoppingcartnetto = returnvalue

            return returnvalue


        },
        project: {
            get() {
                return this.$store.state.projectData.project
            },
            set(value) {
                this.$store.commit('projectData/updateProject', value)
            }
        },
        configuration: {
            get() {
                return this.$store.state.user.configuration
            },
            set(value) {
                this.$store.commit('user/updateConfiguration', value)
            }
        },
        session: {
            get() {
                return this.$store.state.user.session
            },
            set(value) {
                this.$store.commit('user/updateSession', value)
            }
        },
        user: {
            get() {
                return this.$store.state.user.user
            },
            set(value) {
                this.$store.commit('user/updateUser', value)
            }
        },
        selectedlocale: {
            get() {
                return this.$store.state.user.selectedlocale
            },
            set(value) {
                this.$store.commit('user/updateSelectedlocale', value)
            }
        },
        /* draggableOptions() {
          return {
            group: 'multi-drag-group'
          };
        }*/
        draggableOptions() {
            return {
                /*group: {
                  name: 'multi-drag-group'
                },*/
                scrollsensitivity: 200,
                forcefallback: true,
            }
        }


    },
    data() {
        return {
            //counter: 0,
            //count: 0,
            /*  selectedItems:[], */
            discountshow: true,
            shoppingcart_item: {
                'id': null,
                'ref_no': null,
                'version': null,
                'execution': null,
                'type': null,
                'flag_fan': null,
                'state': null,
                'prodgroup': null,
                'max_angle': null,
                'weight': null,
                'voltage': null,
                'max_rpm': null,
                'speedcontrol_type': null,
                'speedcontrol_type1': null,
                'speedcontrol_type2': null,
                'speedcontrol_type3': null,
                'lining': null,
                'explosionproof': null,
                'tempclass': null,
                'rpm1': null,
                'rpm2': null,
                'flc_uncontrolled1': null,
                'flc_uncontrolled2': null,
                'factor_stc_uncontrolled': null,
                'power1': null,
                'power2': null,
                'protectionclass': null,
                'temp_controlled': null,
                'temp_uncontrolled': null,
                'connect_diameter': null,
                'ec_technology': null,
                'wheel_diameter': null,
                'hotair_upto120': null,
                'duct_dimension': null,
                'create_at': null,
                'update_at': null,
                'product_descriptions': [{
                    'id': null,
                    'product_ref_no': null,
                    'product_version': null,
                    'language_id': null,
                    'description_short': null,
                    'description_long': null
                }],
                'product_prices': [{
                    'id': null,
                    'product_ref_no': null,
                    'product_version': null,
                    'pricelist_id': null,
                    'country_id': null,
                    'price': null,
                    'delivery': null
                }],
                'product_media': [{
                    'id': null,
                    'product_ref_no': null,
                    'product_version': null,
                    'media_type': null,
                    'path': null,
                    'filename': null,
                    'country_id': null,
                    'f_download': null
                }],
                'delivery': null,
                'listprice': null,
                'price': null,
                'accessories': [],
                'items': [],
                'positiontext': '',
                'productmarker': null,
                'quantity': null,
                'discount_1': null,
                'discount_2': null,
                'incrementedColumn': null,
                'index': null


            },
            mediaserver_url: '',//'https://globalstest.heliosventilatoren.de' ,
            productmarker_options: [
                {value: 0, text: this.__('lang.shoppingcart.productmarker.options.standard'), visible: true}, // 0 berechnen
                {value: 7, text: this.__('lang.shoppingcart.productmarker.options.alternative'), visible: true}, //7 Alternativ
                {value: 19, text: this.__('lang.shoppingcart.productmarker.options.optional'), visible: true}, //19 optional
                {
                    value: 17,
                    text: this.__('lang.shoppingcart.productmarker.options.recommendedaccessories'),
                    visible: true
                }, //17 empfohlenes Zubehör
                {
                    value: 18,
                    text: this.__('lang.shoppingcart.productmarker.options.necessaryaccessories'),
                    visible: true
                }, //18 notwendiges Zubehör
                {
                    value: 2,
                    text: this.__('lang.shoppingcart.productmarker.options.recommendedaccessories'),
                    visible: false
                }, //2 kostenlos
                {
                    value: 6,
                    text: this.__('lang.shoppingcart.productmarker.options.necessaryaccessories'),
                    visible: false
                }, // 6 nach Aufwand
                {
                    value: 8,
                    text: this.__('lang.shoppingcart.productmarker.options.necessaryaccessories'),
                    visible: false
                }, //  8 Gesamtpreis
                {
                    value: 9,
                    text: this.__('lang.shoppingcart.productmarker.options.necessaryaccessories'),
                    visible: false
                }, //9 wird nachgereicht
            ],
            placeholder_title: this.__('lang.shoppingcart.add.title.placeholder'),
            placeholder_subsumme: this.__('lang.shoppingcart.add.subsumme.placeholder'),
            felderer:{
                version:'1.1',
                result:''
            }


            /* Pagenation and Filtering:
             filter: null,
             currentPage: 1,
             perPage: 5, */
            //counter: 1,

        }
    },
    methods: {
        /*  getCount: function (row,key) {

           if (row.productmarker != -1) this.counter++
           return 1
         }, */
        /*
              onDrop(){
                  console.log('ON DROP')
                  console.log(event)
                  this.$store.commit('shoppingcart/updateShoppingcartList', this.shoppingcartlist)

              },*/

        formatPrice(key) {
            var value = 0
            // Get the current value from the v-model
            value = this.shoppingcartlist[key].price;

            const trimmedvalue = this.shoppingcartlist[key].price.toString().trim();
            const numericvalue = Number(trimmedvalue);

            if (trimmedvalue === '' || isNaN(numericvalue) || numericvalue < 0) value = 0
            value = parseFloat(value).toFixed(2);
            // Update the v-model with the formatted value
            this.shoppingcartlist[key].price = value;
        },
        /* isNumber: function(evt) {
             evt = (evt) ? evt : window.event;
             let charCode = (evt.which) ? evt.which : evt.keyCode;
             if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                 evt.preventDefault();
             } else {
                 return true;
             }
         },*/
        shoppingcartsubsumme: function (k) {
            var returnvalue
            var subsums = []
            let fromItem


            if (!this.user.auth) returnvalue = this.__('lang.message.loginrequired');
            else if (this.user.countries_price == '') returnvalue = this.__('lang.global.onrequest');// + ' PreisLand unbekannt';
            /* else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) returnvalue = this.__('lang.global.onrequest');// + ' fremdes Land'; */
            else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) returnvalue = this.__('lang.global.onrequest');// + ' fremdes Land';
            else {
                var buildssum = true
                var sum = 0
                //for (let i = from_k;
                for (let j = 0; j < this.shoppingcartlist.length; j++) {
                    //.filter(cartrow => cartrow.productmarker == -2).
                    if (this.shoppingcartlist[j].productmarker == -2) subsums.push(j)
                }


                let smaller = subsums.filter(item => item < k);
                if (smaller.length < 1) fromItem = 0
                else fromItem = smaller[smaller.length - 1] + 1


                for (let i = fromItem; i < k && k < this.shoppingcartlist.length; i++) {

                    if (this.shoppingcartlist[i].productmarker == 0) {
                        if (this.discountshow) sum += parseInt(this.shoppingcartlist[i].quantity) * (parseFloat(this.shoppingcartlist[i].price) * (100 - parseFloat(this.shoppingcartlist[i].discount_1)) / 100) * (100 - parseFloat(this.shoppingcartlist[i].discount_2)) / 100
                        else sum += parseInt(this.shoppingcartlist[i].quantity) * parseFloat(this.shoppingcartlist[i].price)
                    } else sum += 0

                }

                /* var sum = this.shoppingcartlist.reduce((accum, item) => {

                  if (item.productmarker != -1 && (isNaN(item.price) || parseFloat(item.price) == 0 || item.price == null)) {
                    buildssum = false
                    return
                  }
                  else if (item.productmarker != 0 || item.productmarker == -1) {
                    return accum += 0
                  }
                  else {
                    if (this.discountshow) return accum += parseInt(item.quantity) * (parseFloat(item.price) * (100 - parseFloat(item.discount_1)) / 100) * (100 - parseFloat(item.discount_2)) / 100
                    else return accum += parseInt(item.quantity) * parseFloat(item.price)
                  }
                }, 0.00) */
                this.shoppingcartlist[k].subsum = sum.toFixed(2);
                if (buildssum) returnvalue = sum.toFixed(2)
                else returnvalue = this.__('lang.global.onrequest')
            }
            from_k = k

            return returnvalue
        },
        savelist() {
            console.log('SAVELIST')
            this.$store.commit('shoppingcart/updateShoppingcartList', this.shoppingcartlist)
        },


        addnewposition: function (productmarker, pos) {
            var newposition = {}

            newposition['flag_fan'] = ''
            newposition['ref_no'] = ''
            newposition['version'] = ''
            newposition['type'] = ''
            newposition['quantity'] = 0
            newposition['discount_1'] = 0
            newposition['discount_2'] = 0;
            newposition['listprice'] = 0
            newposition['price'] = 0
            newposition['positiontext'] = ''
            newposition['image'] = ''
            newposition['description_short'] = ''
            newposition['product_source'] = 2
            newposition['productmarker'] = productmarker
            newposition['incrementedColumn'] = 0

            var idx = productmarker == -1 ? pos : (productmarker == -2 ? pos + 1 : 0)


            this.shoppingcartlist.splice(idx, 0, newposition)
            //this.shoppingcartlist.unshift(newposition);
        },
        opendetail(refno, version, flag_fan, execution, row) {
            var query_params = this.query_params(refno, version, flag_fan, execution, row)


            if (this.user.auth) {
                axios.post('/user/access/token', {navigation: 1}).then(response => {
                    Object.assign(query_params, {access_token: response.data.access_token});
                }).catch(function (error) {
                });
            }
            let routeData = this.$router.resolve({name: 'productdetail', query: query_params});
            window.open(routeData.href, '_blank');
        },
        query_params(refno, version, flag_fan, execution, row) {
            var query_params = {
                ref_no: refno,
                version: version,
                execution: execution,
                language_id: this.$lang().locale, //navigator.language,
            }

            if (flag_fan == 1 && row.op) {
                //http://localhost/de/get/product?ref_no=02337&version=040&language_id=de&airflowrate=10000&externalpressure=200&airflow_unit=1&externalpressure_unit=5&externalpressuretyp=stat&airflowrate_dev=-10&airflowrate_dev=10&externalpressure_dev=-10&externalpressure_dev=10&maxdba=

                Object.assign(query_params, {
                    airflowrate: row.op.op_must.airflowrate ?? '',
                    externalpressure: row.op.op_must.externalpressure ?? '',
                    airflow_unit: row.op.op_must.airflow_unit ?? '',
                    externalpressure_unit: row.op.op_must.externalpressure_unit ?? '',
                    externalpressuretyp: row.op.op_must.externalpressuretyp ?? '',
                    airflowrate_dev: row.op.op_must.airflowrate_dev ?? '', //&airflowrate_dev=-10&airflowrate_dev=10
                    externalpressure_dev: row.op.op_must.externalpressure_dev ?? '',
                    maxdba: row.op.op_must.maxdba ?? '',
                    airflowrate_is: row.op.op_is.airflowrate ?? '',
                    externalpressure_is: row.op.op_is.externalpressure ?? '',
                    wsoll_is: row.op.op_is.wsoll ?? ''

                });

            }

            return query_params
        },
        setFieldLabels: function (value) {
            var array = [];
            var sortable = true

            for (var i = 0; i < value.length; i++) {
                if (value[i].key == 'listprice') {
                    array.push({
                        key: value[i].key,
                        label: this.__(value[i].label),
                        visible: true,
                        sortable: sortable,
                        sortByFormatted: sortable,
                        _showDetails: true,
                        detailsShowing: true,
                        thClass: 'small border-top-0',
                        tdClass: 'text-right',
                        formatter: (value, key, item) => {
                            var price = parseFloat(value);
                            if (!this.user.auth) return this.__('lang.message.loginrequired');
                            else if (this.user.countries_price == '') return this.__('lang.global.onrequest');// + ' PreisLand unbekannt';
                            /* else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest');// + ' fremdes Land'; */
                            else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) return this.__('lang.global.onrequest');// + ' fremdes Land';
                            else return price > 0 ? price.toFixed(2) : this.__('lang.global.onrequest');
                        }
                    })
                } else if (value[i].key == 'price') {
                    array.push({
                        key: value[i].key,
                        label: this.__(value[i].label),
                        visible: true,
                        sortable: sortable,
                        sortByFormatted: sortable,
                        _showDetails: true,
                        detailsShowing: true,
                        thClass: 'small text-nowrap border-top-0',
                        tdClass: 'text-right',
                        formatter: (value, key, item) => {
                            var price = parseFloat(value).toFixed(2);
                            if (!this.user.auth) return this.__('lang.message.loginrequired');
                            else if (this.user.countries_price == '') return this.__('lang.global.onrequest');// + ' PreisLand unbekannt';
                            /* else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest');// + ' fremdes Land'; */
                            else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) return this.__('lang.global.onrequest');// + ' fremdes Land';
                            else return price > 0 ? price.toFixed(2) : this.__('lang.global.onrequest');


                        }
                    })
                } else if (value[i].key == 'discount_1' || value[i].key == 'discount_2') {
                    array.push({
                        key: value[i].key,
                        label: this.__(value[i].label),
                        visible: this.discountshow,
                        sortable: sortable,
                        sortByFormatted: sortable,
                        _showDetails: true,
                        detailsShowing: true,
                        thClass: 'small border-top-0',
                        tdClass: 'text-center',
                        formatter: (value, key, item) => {
                            return parseFloat(value);
                        }
                    })
                } else if (value[i].key == 'totalprice') {
                    array.push({
                        key: value[i].key,
                        label: this.__(value[i].label),
                        visible: true,
                        sortable: sortable,
                        sortByFormatted: sortable,
                        _showDetails: true,
                        detailsShowing: true,
                        thClass: 'small text-nowrap border-top-0',
                        tdClass: 'text-right',
                        formatter: (value, key, item) => {

                            if (this.discountshow) var price = parseInt(item.quantity) * (parseFloat(item.price) * (100 - parseFloat(item.discount_1)) / 100) * (100 - parseFloat(item.discount_2)) / 100
                            else var price = parseInt(item.quantity) * parseFloat(item.price)

                            if (!this.user.auth) return this.__('lang.message.loginrequired');
                            else if (this.user.countries_price == '') return this.__('lang.global.onrequest'); //+ ' PreisLand unbekannt';
                            /* else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest'); //+ ' fremdes Land'; */
                            else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) return this.__('lang.global.onrequest'); //+ ' fremdes Land';
                            else return price > 0 ? price.toFixed(2) : this.__('lang.global.onrequest');

                        }
                    })
                } else if (value[i].key == 'position') {
                    sortable = true
                    array.push({
                        key: value[i].key,
                        label: this.__(value[i].label),
                        visible: true,
                        sortable: sortable,
                        headerSort: false,
                        sortByFormatted: sortable,
                        _showDetails: true,
                        detailsShowing: true,
                        thClass: 'small text-nowrap border-top-0',
                        thStyle: 'background:none',
                        tdClass: 'text-center',
                        formatter: (value, key, item) => {
                            var price = parseFloat(value);
                            return price > 0 ? price.toFixed(2) : this.__('lang.global.onrequest');
                        }
                    })

                } else {
                    if (value[i].key == 'info' || value[i].key == 'cloud' || value[i].key == 'productmarker') sortable = false
                    array.push({
                        key: value[i].key,
                        label: this.__(value[i].label),
                        visible: true,
                        sortable: sortable,
                        sortByFormatted: sortable,
                        _showDetails: true,
                        detailsShowing: true,
                        thClass: 'small text-nowrap border-top-0',
                        formatter: (value, key, item) => {
                            if (typeof value == "number") return Math.round(value);
                            else return value;
                        }
                    })
                }
            }

            return array;
        },
        setCartItem(row, index) {
            //if(row=='productdata'&& index==-1) this.shoppingcart_item=this.shoppingcartlist[0] //??

            Object.assign(this.shoppingcart_item, row);

            if (!this.user.auth || this.user.countries_price == '' || (this.user.auth && this.user.countries_price != this.selectedlocale.country)) {
                this.shoppingcart_item.listprice = 0
                this.shoppingcart_item.price = 0
            }
            Object.assign(this.shoppingcart_item, {index: index})
            if (row.product_source == 1) this.getProductAccessories(row.ref_no, row.version)
        },
        updateConfiguration() {
            this.$refs.shoppingcartsave.updateConfiguration()
        },
        setProjectData() {
            this.$refs.shoppingcartsave.setData()
        },
        set_contentnav() {
            var search_flag = 'showresult'//this.$store.state.shoppingcart.search_flag
            this.$parent.listenerchild({nav: "2", searchflag: search_flag})
        },
        getUserArticles() {
            this.$refs.ownArticleCreate.getUserArticles()
        },
        gotostartpage() {
            this.$root.$emit("gotostartpage", {
                from: "Shoppingcart"
            })

        },

        /* Test for API gesamt WK  */
        getWKArticles() {
            axios.post('/api/return/configuration/articles', {
                configurations: [{
                    configuration_id: 137,
                    project_id: 92
                }]
            }).then(response => {

            }).catch(function (error) {

            });

        },
        createFeldererJson() {
            var list = [];
            var cartitem = {};
            this.shoppingcartlist.filter(row => row.product_source == 1 && row.productmarker != -1 && row.productmarker != -2).forEach(function (cartrow) {
                //var rowsum=this.shoppingcartrowsumme(cartrow.price, cartrow.quantity, cartrow.discount_1, cartrow.discount_2, 1)
                //PRICE_QUANTITY:rowsum,
                //PRICE_AMOUNT:cartrow.price,
                cartitem = {
                    MANUFACTURER_PID: cartrow.ref_no,
                    MANUFACTURER_TYPE_DESC: cartrow.type,
                    DESCRIPTION_SHORT: cartrow.description_short,
                    QUANTITY: cartrow.quantity,
                    ORDER_UNIT: "ST",
                    SUPPLIER_ID_GLN: "4010184000006",

                }
                list.push(cartitem);
            })
            var strJson = JSON.stringify (list);
            return (strJson);
        },
        async logoutAndSubmit() {
            try {


                await userApi.logout(this.session);
                document.start.submit();
            } catch (error) {
                console.error("Logout failed:", error);
            }
        },
/*
        // Attach event listener to the form
        document.getElementById('start').addEventListener('submit', function(event) {
            event.preventDefault(); // Prevent the default form submission

            // Call the logoutAndSubmit function with the correct context
            logoutAndSubmit.call({ session: this.session });
        }),*/

        sendToFelderer() {
            var strJson=this.createFeldererJson();
            var result =[];
            result.push(strJson);

            document.getElementById('version').value='1.0'
            document.getElementById('result').value=result;

            this.logoutAndSubmit.call({ session: this.session });

            /*if(response)   document.start.submit();
            else  console.log('logoutUser response');*/

/*
            felderer.createfeldererbasket(felderer_data)
                .then(response => {
                    console.log('createfeldererbasket response');
                })
                .catch(function () {
                    console.log('createfeldererbasket catch');
                })*/
            /*

            axios.post('https://www.felderer24.de/elbridge/accept/Helios',felderer_data , {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                //go to felderer?

            }).catch(function (error) {
                //go to heliosselect shoppingcart?
            });*/
        },




        async getProductAccessories(ref_no, version) {
            this.$refs.add_from_shoppingcart.getProductAccessories(ref_no, version)
        },
        /* check product for country, get country/language data for products in shoppingcart*/
         getProductInfo() {
            var localshoppingcart = this.$store.state.shoppingcart.shoppingcartlist
            var show_price = false
            var price = 0
            var lang = this.selectedlocale.language //this.$lang().locale
            var country = this.selectedlocale.country
            /* if (this.user.auth && this.user.countries_price == this.selectedlocale.country && this.user.countries_price == this.user.countries_iso) { */
            if (this.user.auth && this.user.countries_price == this.selectedlocale.country) {
                show_price = true
            }


//-- comment for description_long in popover     if (this.reRenderShoppingcart == 1) {
            localshoppingcart.sort((a, b) => a.position - b.position)

            localshoppingcart.filter(row => row.product_source == 1 && row.productmarker != -1 && row.productmarker != -2).forEach(function (cartitem) {

                var params = {
                    ref_no: cartitem.ref_no,
                    version: (cartitem.version ? cartitem.version : cartitem.product_child_version),
                    language_id: lang,
                    country: country
                }  //navigator.language,}
                 productdataApi.getProductInfo(params)
                    .then(response => {

                        if (show_price && response.data.productdata[0].product_prices[0].price > 0) price = response.data.productdata[0].product_prices[0].price
                        else price = 0
                        let desc_short = response.data.productdata[0].product_descriptions[0].description_short ? response.data.productdata[0].product_descriptions[0].description_short : ''
                        let desc_long = response.data.productdata[0].product_descriptions[0].description_long ? response.data.productdata[0].product_descriptions[0].description_long : ''


                        Object.assign(cartitem, {
                            description_short: desc_short,
                            listprice: price,
                            validstate: response.data.productdata[0].validstate,
                            description_long: response.data.productdata[0].product_descriptions[0].description_long,
                        });

                    })
                    .catch(function () {
                        console.log('shoppingcart getProductInfo');
                    })

            })
//--      }
            //this.reRenderShoppingcart = 0
            //
            /* ToDo: was entcomment for #221, test with load configuration!????*/
            //--this.$store.commit('shoppingcart/updateShoppingcartList', localshoppingcart)


            var idx_increment = 0
            localshoppingcart.filter(row => row.productmarker != -1 && row.productmarker != -2).forEach(function (row) {
                idx_increment++
                Object.assign(row, {
                    incrementedColumn: idx_increment
                });

            })


            return localshoppingcart

        },
        shoppingcartrowprice: function (price) {
            var price = parseFloat(price);
            if (!this.user.auth) price = this.__('lang.message.loginrequired');
            else if (this.user.countries_price == '') price = this.__('lang.global.onrequest');// + ' PreisLand unbekannt';
                /* else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest'); //+ ' fremdes Land'; */
            // 2023-11-28 editprices => sollte grechnet werden mit editprice else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) price= this.__('lang.global.onrequest'); //+ ' fremdes Land';
            else price = price > 0 ? price.toFixed(2) : this.__('lang.global.onrequest');

            return price
        },
        shoppingcartrowsumme: function (price, quantity, discount1, discount2, productmarker) {
            var rowsumme = 0
            if (productmarker == 0) {
                if (this.discountshow) var price = parseInt(quantity) * (parseFloat(price) * (100 - parseFloat(discount1)) / 100) * (100 - parseFloat(discount2)) / 100
                else var price = parseInt(quantity) * parseFloat(price)

                if (!this.user.auth) rowsumme = this.__('lang.message.loginrequired');
                else if (this.user.countries_price == '') rowsumme = this.__('lang.global.onrequest'); //+ ' PreisLand unbekannt';
                    /* else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest'); //+ ' fremdes Land'; */
                // 2023-11-28 editprices => sollte grechnet werden mit editprice else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) rowsumme = this.__('lang.global.onrequest'); //+ ' fremdes Land';
                else rowsumme = price > 0 ? price.toFixed(2) : this.__('lang.global.onrequest');


            } else rowsumme = '-'

            return rowsumme
        },
        resetConfiguration() {

            //this.$store.commit('user/updateConfiguration', null)
            //this.$store.commit('user/updateProjectTmp',null)


            this.$store.dispatch('shoppingcart/resetState')
            this.$store.dispatch('globalData/resetState')
            //this.$store.dispatch('user/resetState')
            this.$store.commit('user/updateConfiguration', null)
            this.$store.dispatch('validation/resetState')
            this.$store.dispatch('projectData/resetState')
            this.$store.dispatch('operatingpoint/resetState')
            this.$store.dispatch('alert/resetState')
            this.$store.commit('globalData/updateContentnav', 1)


        },
        getLongDesc(desc) {
            var str = ''
            if (desc != null) str = desc.replace(/(<([^>]+)>)/ig, '');
            return str.length > 255 ? str.substring(0, 255) + '...' : str;
        },

    },
    mounted() {

        this.reRenderShoppingcart = 0
        //this.$forceUpdate();
        this.$nextTick()

    },
    created() {
        this.shoppingcartlist.sort((a, b) => a.position - b.position)

    },
    watch: {

        '$store.state.shoppingcart.shoppingcartlist': {

            immediate: true,
            deep: true,
            handler(newList, oldList) {
                console.log('shoppingcart watch')
                // update locally relevant data
                this.shoppingcartlist = this.$store.state.shoppingcart.shoppingcartlist;

                /*

                        this.shoppingcartlist.forEach(row => {
                           if (row.productmarker === 0) {
                               row.incrementedColumn++;
                          }
                        }) */
                ;


            }

        },


    }
}
</script>
<style scoped>
.table td.border-b-red {
    border-bottom: 1px solid #e20020;
}

.table td.border-b-red input {
    font-size: 1.25rem
}

.table td.border-b-red input::placeholder {
    color: #6c757d;
    font-style: italic;
}

/* .table td.border-t-grey input {
  font-size: 0.75rem;
} */
.table td.border-t-grey input::placeholder {
    font-style: italic;
}
.jumbotron {

    /*background-color: #006838 !important;*/
    background-color: #e20020 !important

}
.jumbotron-select{
        background: none !important;
        overflow: visible;

}

</style>

